import gql from "graphql-tag";

// fragment
export const GROWTH_TASK_INENTORY_BY_PLANT_FRAGMENT = gql`
    fragment inventoryByPlant on GrowthTaskInventoryByPlantNode {
        id
        tenant {
            id
            name
        }
        plant {
            id
            name
            plantSpecies {
                id
                name
            }
        }
        potSize {
            id
            potSizeCm
        }
        color {
            id
            color
        }
        environment {
            id
            environment
        }
        tag {
            id
            tag
        }
        totalQuantity
        totalInventory
        inventoryReadySales
        inventoryWeek1
        inventoryWeek2
        inventoryWeek3AndAfter
        updatedAt
    }
`;

// all query
export const GROWTH_TASK_INVENTORY_BY_PLANT_QUERY = gql`
    query {
        tenantGrowthTaskInventoryByPlants {
            edges {
                cursor
                node {
                    ...inventoryByPlant
                }
            }
        }
    }
    ${GROWTH_TASK_INENTORY_BY_PLANT_FRAGMENT}
`;
